// useAuthActions hook - access auth actions

import { useContext } from "react";
import { AuthActionsContext } from "./auth-context";

/**
 * Access authentication actions
 *
 * @returns {Object} Auth actions
 * @returns {Function} setUser - Update current user state
 * @returns {Function} logOut - Log out current user
 *
 * @throws {Error} If used outside AuthProvider
 *
 * @example
 * function LogoutButton() {
 *   const { logOut } = useAuthActions();
 *
 *   return (
 *     <button onClick={logOut}>
 *       Sign Out
 *     </button>
 *   );
 * }
 */
export function useAuthActions() {
  const context = useContext(AuthActionsContext);

  if (!context) {
    throw new Error("useAuthActions must be used within AuthProvider");
  }

  return context;
}
